"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkButtonWithCtx = exports.mapStateToProps = exports.LinkButton = exports.checkLinkButtonIsMatchedRouterLocation = exports.getDecoratedMenuLinkName = void 0;
var react_1 = __importDefault(require("react"));
var react_router_1 = require("react-router");
var core_1 = require("@material-ui/core");
var buttonContext_1 = __importStar(require("./buttonContext"));
var react_function_helpers_1 = require("react-function-helpers");
var fn_1 = require("./fn/fn");
var basicSingleLink_1 = __importDefault(require("./static/basicSingleLink"));
var CustomLink_1 = __importDefault(require("./CustomLink"));
exports.getDecoratedMenuLinkName = function (name, isMenuLink) { return (!!isMenuLink ? name + '  ▾' : name); };
exports.checkLinkButtonIsMatchedRouterLocation = function (_a) {
    var href = _a.href, linkChildren = _a.linkChildren, pathname = _a.pathname;
    var link = __assign(__assign({}, basicSingleLink_1.default), { link: fn_1.convertHrefToLinkString(href), children: fn_1.convertlinkChildrenToArray(linkChildren) });
    var isMatchedRouterLocation = fn_1.checkLinkIsMatched(link, pathname);
    return isMatchedRouterLocation;
};
var useStyles = core_1.makeStyles(function (theme) {
    var _a;
    return ({
        root: (_a = {
                // backgroundColor: theme.palette.primary.main,
                paddingTop: function (props) { return theme.spacing(props.linkButtonStyle.paddingTopBottom); },
                paddingBottom: function (props) { return theme.spacing(props.linkButtonStyle.paddingTopBottom); },
                paddingLeft: function (props) { return theme.spacing(props.linkButtonStyle.paddingLeftRight); },
                paddingRight: function (props) { return theme.spacing(props.linkButtonStyle.paddingLeftRight); },
                opacity: function (props) { return !!props.isSelected ? 0.5 : 1; },
                '&:hover': {
                // backgroundColor: theme.palette.primary.light,
                }
            },
            _a[theme.breakpoints.down('sm')] = {
                width: '100%',
            },
            _a)
    });
});
exports.LinkButton = function (props) {
    var href = props.href, isTargetBlank = props.isTargetBlank, linkName = props.linkName, isMenuLink = props.isMenuLink, linkButtonStyle = props.linkButtonStyle, onClick = props.onClick;
    var classes = useStyles(props);
    return (react_1.default.createElement(core_1.Box, { padding: 0.5 },
        react_1.default.createElement(CustomLink_1.default, { isTargetBlank: isTargetBlank, href: href },
            react_1.default.createElement(core_1.Button, { className: classes.root, "aria-controls": "basic-menu", "aria-haspopup": "true", "is-selected": props.isSelected ? "true" : "false", variant: linkButtonStyle.buttonVariant, color: linkButtonStyle.buttonColor, onClick: onClick },
                react_1.default.createElement(core_1.Typography, { variant: linkButtonStyle.variant }, exports.getDecoratedMenuLinkName(linkName, isMenuLink))))));
};
exports.mapStateToProps = function (state) {
    return ({
        linkButtonStyle: __assign(__assign({}, buttonContext_1.defaultLinkButtonStyle), state.linkButtonStyle),
    });
};
exports.LinkButtonWithCtx = react_function_helpers_1.connectCtx(buttonContext_1.default)(exports.mapStateToProps)(exports.LinkButton);
var LinkButtonWithRouter = function (props) {
    var href = props.href, linkChildren = props.linkChildren;
    var pathname = react_router_1.useHistory().location.pathname;
    var isMatchedRouterLocation = exports.checkLinkButtonIsMatchedRouterLocation({
        href: href, linkChildren: linkChildren, pathname: pathname
    });
    return (react_1.default.createElement(exports.LinkButtonWithCtx, __assign({}, props, { isSelected: isMatchedRouterLocation })));
};
exports.default = LinkButtonWithRouter;
